













































































































































































































































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'
import { RealworksKenmerk } from '@/api/model/realworks-kenmerk'
import { CredentialsType, ReferralChannel } from '@/api/types'
import { RealworksCredentials } from '@/api/model/credentials'
import { Pipeline } from '@/api/model/pipeline'
import { InputSelectOption } from '@/helpers/options'
import { usePipelineConnections } from '@/composables/usePipelineConnections'
import { CompanyAPI, RealworksKenmerkAPI, SourceAPI, TriggeredReferralAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { ReferralNode } from '@/api/model/referral-node'
import { Source } from '@/api/model/source'
import { RealworksAPI } from '@/api/client/realworks'
import { escapeHtml } from '@/helpers/html'
const pipelineConnections = usePipelineConnections(false)

@Component
export default class TriggeredReferralForm extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredReferral
    @Prop({ required: true }) readonly create: boolean
    legacyOutgoingReferrals: ReferralNode[] = []
    legacyAvailableBranches: Branch[] = []
    pipelines: Pipeline[] = []
    kenmerken: RealworksKenmerk[] = []
    loadingTaakTypes: boolean = true
    taakTypes: InputSelectOption[] = []
    loadingTaakStatussen: boolean = true
    taakStatussen: InputSelectOption[] = []
    loadingAgendaTypes: boolean = true
    agendaTypes: InputSelectOption[] = []
    loadingAgendaStatussen: boolean = true
    agendaStatussen: InputSelectOption[] = []
    loadingRelatieTypes: boolean = true
    relatieTypes: InputSelectOption[] = []
    sources: Source[] = []
    triggerType: string = null
    loading: boolean = false
    saving: boolean = false
    id: string = null
    active: boolean = false
    referralType: string = null
    pipeline: Pipeline = null
    assignedTo: User = null
    assignedToBranch: Branch = null
    referredBy: User = null
    referredByBranch: Branch = null
    realworksCredential: string = null
    realworksKenmerk: number = null
    selectedAgendaTypes: string[] = []
    selectedAgendaStatus: string = 'empty'
    selectedTaakTypes: string[] = []
    selectedTaakStatus: string = 'empty'
    selectedRelatieTypes: string[] = []
    source: string = null
    newSource: Source = null
    comment: string = null
    maxDaysForExistingReferrals: number = 7

    mounted() {
        this.loadAgendaTypes()
        this.loadAgendaStatussen()
        this.loadTaakTypes()
        this.loadTaakStatussen()
        this.loadRelatieTypes()
    }

    async created() {
        await this.loadContent()
        await this.applyValue()

        this.autoSelectFirstCredentials()
        this.autoSelectFirstPipeline()
        this.autoSelectFirstReferralType()
    }

    @Watch('value')
    async applyValue(): Promise<void> {
        if (!this.value) {
            this.id = uuid()
            this.active = true
            this.triggerType = 'kenmerken'
            return
        }

        this.id = this.value.id
        this.active = this.value.active
        this.triggerType = this.value.triggerType
        this.referralType = this.value.referralType
        this.pipeline = this.value.referralPipeline
        this.assignedTo = this.value.referralAssignedTo
        this.assignedToBranch = this.value.referralAssignedToBranch
        this.referredBy = this.value.referralReferredBy
        this.referredByBranch = this.value.referralReferredByBranch
        this.realworksCredential = this.value.realworksCredentials?.id
        this.realworksKenmerk = this.value.realworksKenmerkId ? Number.parseInt(this.value.realworksKenmerkId, 10) : null
        this.selectedAgendaTypes = this.value.agendaTypes.slice()
        this.selectedAgendaStatus = this.value.agendaStatus ?? 'empty'
        this.selectedTaakTypes = this.value.taakTypes.slice()
        this.selectedTaakStatus = this.value.taakStatus ?? 'empty'
        this.selectedRelatieTypes = this.value.relatieTypes.slice()
        this.source = this.value.referralSource
        this.newSource = this.value.referralNewSource
        this.comment = this.value.referralComment
        this.maxDaysForExistingReferrals = this.value.maxDaysForExistingReferrals

        // since value (TriggeredReferral) does not send its pipeline branches, we
        // replace the pipeline with one from our own loaded data
        if (this.pipeline) {
            this.pipeline = this.availablePipelines.find(p => p.id === this.pipeline.id)
        }

        // legacy
        if (this.referralType) {
            await this.updateLegacyAvailableBranches()
        }
    }

    @Watch('triggerType')
    onTriggerTypeChanged(): void {
        if (this.triggerType !== 'kenmerken') {
            this.realworksKenmerk = null
        }

        if (this.triggerType !== 'agendaTypes') {
            this.selectedAgendaTypes = []
            this.selectedAgendaStatus = 'empty'
        }

        if (this.triggerType !== 'taakTypes') {
            this.selectedTaakTypes = []
            this.selectedTaakStatus = 'empty'
        }

        if (this.triggerType !== 'relatieTypes') {
            this.selectedRelatieTypes = []
        }
    }

    async loadContent(): Promise<void> {
        this.loading = true

        if (this.$currentCompany.pipelinesEnabled) {
            await pipelineConnections.loadPipelineConnections()
            this.pipelines = pipelineConnections.buildOutgoingPipelines({ includeOwn: true })

        } else {
            this.legacyOutgoingReferrals = await CompanyAPI.getOutgoingReferrals()
        }

        this.kenmerken = await RealworksKenmerkAPI.getAll()
        this.loading = false
    }

    async save(): Promise<void> {
        try {
            this.saving = true
            const triggeredReferral = this.generateTriggeredReferral()

            if (this.create) {
                await TriggeredReferralAPI.create(triggeredReferral)

            } else {
                await TriggeredReferralAPI.update(triggeredReferral.id, triggeredReferral)
            }

            this.$emit('save')

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.saving = false
        }
    }

    generateTriggeredReferral(): TriggeredReferral {
        return TriggeredReferral.fromData({
            id: this.id,
            company: this.$currentCompany,
            active: this.active,
            referralType: this.referralType,
            referralPipeline: this.pipeline,
            referralAssignedTo: this.assignedTo,
            referralAssignedToBranch: this.assignedToBranch,
            referralReferredBy: this.referredBy,
            referralReferredByBranch: this.referredByBranch,
            realworksCredentials: this.availableRealworksCredentials.find(c => c.id === this.realworksCredential),
            realworksKenmerkId: this.realworksKenmerk ? this.realworksKenmerk.toString() : null,
            agendaTypes: this.selectedAgendaTypes,
            agendaStatus: this.selectedAgendaStatus !== 'empty' ? this.selectedAgendaStatus : null,
            taakTypes: this.selectedTaakTypes,
            taakStatus: this.selectedTaakStatus !== 'empty' ? this.selectedTaakStatus : null,
            relatieTypes: this.selectedRelatieTypes,
            referralSource: this.source,
            referralNewSource: this.newSource,
            referralComment: this.comment,
            maxDaysForExistingReferrals: this.maxDaysForExistingReferrals,
        })
    }

    @Watch('referralType')
    async updateLegacyAvailableBranches(): Promise<void> {
        if (!this.referralType) {
            this.legacyAvailableBranches = []
            return
        }

        this.legacyAvailableBranches = (await Promise.all(this.legacyOutgoingReferrals
            .filter((node: ReferralNode) => node.active === true)
            .filter((node: ReferralNode) => node.type === this.referralType)
            .map(async (node: ReferralNode) => {
                const company = await CompanyAPI.get(node.target.id)

                // A company that can't be fetched has no branches to offer
                return (company?.getAvailableBranches() ?? [])
                    .filter((branch: Branch) => branch.acceptsReferralType(this.referralType))
                    .sort((a: Branch, b: Branch) => a.name.localeCompare(b.name))

            }))).flat() as Branch[]
    }

    autoSelectFirstCredentials(): void {
        if (this.availableRealworksCredentials.length === 1) {
            this.realworksCredential = this.availableRealworksCredentials[0].id
        }
    }

    @Watch('realworksCredential')
    autoSelectFirstKenmerk(): void {
        if (this.availableRealworksKenmerken.length === 1) {
            this.realworksKenmerk = Number.parseInt(this.availableRealworksKenmerken[0].id, 10)
        }
    }

    autoSelectFirstPipeline(): void {
        if (this.$currentCompany.pipelinesEnabled && this.availablePipelines.length === 1) {
            this.pipeline = this.availablePipelines[0]
        }
    }

    autoSelectFirstReferralType(): void {
        if (!this.$currentCompany.pipelinesEnabled && this.availableReferralTypes.length === 1) {
            this.referralType = this.availableReferralTypes[0]
        }
    }

    @Watch('pipeline')
    @Watch('legacyAvailableBranches')
    autoSelectFirstAssignedToBranch(): void {
        if (this.availableAssignedToBranches.length === 1) {
            this.assignedToBranch = this.availableAssignedToBranches[0]
        }
    }

    @Watch('pipeline')
    async updateSources(): Promise<void> {
        if (!this.pipeline) {
            this.sources = this.$currentCompany.activeSources
            return
        }

        this.sources = await SourceAPI.getAll({
            company: this.pipeline.company.id,
            channel: ReferralChannel.REALWORKS,
            active: 1,
        })
    }

    get externalPipelineSelected(): boolean {
        return this.pipeline && this.pipeline.company.id !== this.$currentCompany.id
    }

    get availablePipelines(): Pipeline[] {
        return this.pipelines
            .filter(pipeline => pipeline.active)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get availableReferralTypes(): string[] {
        return this.$currentCompany.handledOutgoingReferralTypes
            .sort((a, b) => a.localeCompare(b))
    }

    get availableRealworksCredentials(): RealworksCredentials[] {
        return this.$currentCompany
            .getCredentialsWithType<RealworksCredentials>(CredentialsType.REALWORKS)
            .sort((a, b) => a.description.localeCompare(b.description))
    }

    get availableRealworksKenmerken(): RealworksKenmerk[] {
        return this.kenmerken
            .sort((a, b) => a.omschrijving.localeCompare(b.omschrijving))
    }

    get availableAssignedToBranches(): Branch[] {
        if (!this.pipeline) {

            // legacy
            if (this.referralType) {
                return this.legacyAvailableBranches
            }

            return []
        }

        return this.pipeline.branches
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get availableAssignedTo(): User[] {
        if (!this.isOwnPipeline || !this.assignedToBranch) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.assignedToBranch,
        })
    }

    get availableReferredBy(): User[] {
        if (!this.referredByBranch) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.referredByBranch,
        })
    }

    get availableReferredByBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get referralTypeOptions(): InputSelectOption[] {
        return this.availableReferralTypes
            .map(type => ({
                label: this.$t(`referral.type.${ type }`).toString(),
                value: type,
            }))
    }

    get realworksCredentialOptions(): InputSelectOption[] {
        return this.availableRealworksCredentials
            .filter(realworksCredentials => {
                if (this.triggerType === 'agendaTypes') {
                    return realworksCredentials.canRequestAgenda
                }

                if (this.triggerType === 'taakTypes') {
                    return realworksCredentials.canRequestTaken
                }

                return realworksCredentials.canRequestRelaties
            })
            .map(realworksCredentials => ({
                label: realworksCredentials.description,
                value: realworksCredentials.id,
            }))
    }

    get realworksKenmerkenOptions(): InputSelectOption[] {
        return this.availableRealworksKenmerken
            .map(kenmerk => ({
                label: kenmerk.omschrijving,
                value: kenmerk.id,
            }))
    }

    get validSources(): InputSelectOption[] {
        return this.sources.map(source => ({
            label: source.name,
            subtext: this.$t(`channel.${source.channel}`).toString(),
            value: source.id,
        }))
    }

    get isOwnPipeline(): boolean {
        if (!this.pipeline) {
            return false
        }

        return this.pipeline?.company?.id === this.$currentCompany?.id
    }

    get referralNewSource(): string|null {
        return this.newSource?.id || null
    }

    set referralNewSource(id: string|null) {
        this.newSource = this.$currentCompany.activeSources
            .find(source => source.id === id)
    }

    get triggerTypeOptions() {
        return [
             { label: this.$t('company_settings.triggered_referrals_form.trigger-types.kenmerken'), value: 'kenmerken' },
             { label: this.$t('company_settings.triggered_referrals_form.trigger-types.agenda-types'), value: 'agendaTypes' },
             { label: this.$t('company_settings.triggered_referrals_form.trigger-types.taak-types'), value: 'taakTypes' },
             { label: this.$t('company_settings.triggered_referrals_form.trigger-types.relatie-types'), value: 'relatieTypes' },
        ]
    }

    async loadAgendaTypes() {
        this.loadingAgendaTypes = true

        const agendaTypes = await RealworksAPI.getAgendatypes()
        this.agendaTypes = agendaTypes
            .map(agendatype => ({
                label: agendatype,
                value: agendatype,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingAgendaTypes = false
    }

    async loadAgendaStatussen() {
        this.loadingAgendaStatussen = true

        const agendaStatussen = await RealworksAPI.getAgendaStatussen()
        this.agendaStatussen = agendaStatussen
            .filter(status => status.actief)
            .sort((a, b) => a.volgorde > b.volgorde ? 1 : -1)
            .map(status => ({
                label: status.status,
                value: status.status,
            }))

        this.agendaStatussen.unshift({
            label: this.$t('forms.edit_realworks_status_rule_form.emptyAgendaStatus').toString(),
            value: 'empty',
        })

        this.loadingAgendaStatussen = false
    }

    async loadTaakTypes() {
        this.loadingTaakTypes = true

        const taakTypes = await RealworksAPI.getTaaktypes()
        this.taakTypes = taakTypes
            .map(taak => ({
                label: taak,
                value: taak,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingTaakTypes = false
    }

    async loadTaakStatussen() {
        this.loadingTaakStatussen = true

        const taakStatussen = await RealworksAPI.getTaakStatussen()
        this.taakStatussen = taakStatussen
            .filter(status => status.actief)
            .sort((a, b) => a.volgorde > b.volgorde ? 1 : -1)
            .map(status => ({
                label: status.status,
                value: status.status,
            }))

        this.taakStatussen.unshift({
            label: this.$t('forms.edit_realworks_status_rule_form.emptyTaakStatus').toString(),
            value: 'empty',
        })

        this.loadingTaakStatussen = false
    }

    async loadRelatieTypes() {
        this.loadingRelatieTypes = true

        const relatieTypes = await RealworksAPI.getRelatietypes()
        this.relatieTypes = relatieTypes
            .map(relatietype => ({
                label: relatietype,
                value: relatietype,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingRelatieTypes = false
    }
}
